import { default as ReactSelect, components } from 'react-select'
import { TAGS } from '../services/Tags'
import { useQuery } from '@tanstack/react-query'
import { getListOfSkillsCategories } from '../services/talents'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const SkillChip = ({ skill, isRequired, onRequiredChange }) => {
  const [hovered, setHovered] = useState(false)

  return (
    <div
      className="d-flex align-items-center gap-1 border rounded px-2 py-1"
      style={{
        fontSize: '13px',
        cursor: 'default',
        backgroundColor: isRequired ? '#e8f5e9' : '',
        borderColor: isRequired ? '#4caf50' : '',
        transition: 'background-color 0.15s',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span>{skill.label}</span>
      <label
        className="d-flex align-items-center gap-1 mb-0 ms-1"
        style={{
          cursor: 'pointer',
          userSelect: 'none',
          opacity: hovered || isRequired ? 1 : 0,
          transition: 'opacity 0.15s',
        }}
      >
        <input
          type="checkbox"
          checked={isRequired}
          onChange={(e) => onRequiredChange(skill.value, e.target.checked)}
        />
        <span style={{ color: '#555' }}>Requerida</span>
      </label>
    </div>
  )
}

const SelectSkills = ({
  setSelectedSkills,
  defaultSelectedSkills = null,
  amountSkills = 12,
}) => {
  const { t } = useTranslation()
  const [optionSelected, setOptionSelected] = useState(defaultSelectedSkills)
  const [requiredSkills, setRequiredSkills] = useState({})
  const errorMaxSkills = optionSelected?.length > amountSkills

  const { data: skillsCategoriesData = [] } = useQuery(
    [TAGS.get_skills_categories],
    getListOfSkillsCategories
  )

  const transformData = skillsCategoriesData?.map((props) => {
    return {
      value: props.id,
      label: props.skill.name,
    }
  })

  const handleChange = (selected) => {
    setOptionSelected(selected)
  }

  const handleRequiredChange = (skillId, checked) => {
    setRequiredSkills((prev) => ({ ...prev, [skillId]: checked }))
  }

  useEffect(() => {
    const withRequired = optionSelected?.map((skill) => ({
      ...skill,
      required: requiredSkills[skill.value] ?? false,
    }))
    setSelectedSkills(withRequired)
  }, [optionSelected, requiredSkills])

  return (
    <>
      <ReactSelect
        options={transformData}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option: (props) => (
            <components.Option {...props}>
              <div className="d-flex align-items-center justify-content-between w-100">
                <label style={{ marginBottom: 0, cursor: 'pointer', flex: 1 }}>
                  {props.label}
                </label>
                {props.isFocused && (
                  <label
                    className="d-flex align-items-center gap-1 mb-0 ms-2"
                    style={{ cursor: 'pointer', userSelect: 'none', fontSize: '12px', whiteSpace: 'nowrap' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      type="checkbox"
                      checked={requiredSkills[props.data.value] ?? false}
                      onChange={(e) => {
                        e.stopPropagation()
                        const isChecked = e.target.checked
                        // Si no está seleccionado, agregarlo a la selección
                        if (!props.isSelected && isChecked) {
                          handleChange([...(optionSelected ?? []), props.data])
                        }
                        // Si está seleccionado y se desmarca el required, no deseleccionar
                        handleRequiredChange(props.data.value, isChecked)
                      }}
                    />
                    <span>Requerida</span>
                  </label>
                )}
              </div>
            </components.Option>
          ),
        }}
        onChange={handleChange}
        value={optionSelected}
        noOptionsMessage={() => 'Habilidad no disponible'}
        placeholder={t('choose_the_skills')}
        required
      />

      {errorMaxSkills && (
        <span className="text-danger">solo puedes seleccionar 12</span>
      )}

      {optionSelected?.length > 0 && (
        <div className="mt-2 d-flex flex-wrap gap-2">
          {optionSelected.map((skill) => (
            <SkillChip
              key={skill.value}
              skill={skill}
              isRequired={requiredSkills[skill.value] ?? false}
              onRequiredChange={handleRequiredChange}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default SelectSkills
